import { useState } from 'react';

export default function Benefits() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const benefits = [
    {
      icon: 'ri-file-list-3-line',
      title: 'Avaliação + Plano Personalizado',
      description: 'Receba uma avaliação completa e um plano totalmente adaptado aos seus objetivos e necessidades',
      color: 'from-teal-100 to-teal-200',
      iconColor: 'text-teal-600'
    },
    {
      icon: 'ri-book-open-line',
      title: 'E-Book com Dicas Práticas',
      description: 'Guia completo com dicas práticas e estratégias comprovadas para acelerar seus resultados',
      color: 'from-lime-100 to-lime-200',
      iconColor: 'text-lime-600'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'Menus Equilibrados e Fáceis',
      description: 'Planos alimentares equilibrados, simples de seguir e deliciosos para o seu dia a dia',
      color: 'from-orange-100 to-orange-200',
      iconColor: 'text-orange-600'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Acompanhamento Diário + Grupo',
      description: 'Suporte diário e acesso ao grupo exclusivo de motivação com outros participantes',
      color: 'from-pink-100 to-pink-200',
      iconColor: 'text-pink-600'
    },
    {
      icon: 'ri-play-circle-line',
      title: 'Acesso a Treinos Online',
      description: 'Treinos em vídeo para fazer onde e quando quiser, no conforto da sua casa ou ginásio',
      color: 'from-purple-100 to-purple-200',
      iconColor: 'text-purple-600'
    }
  ];

  return (
    <section id="vantagens" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-gradient-to-r from-teal-500 to-lime-500 text-white px-6 py-2 rounded-full text-sm font-bold mb-6">
            100% GRÁTIS
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            O Que Recebes Totalmente GRÁTIS
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Tudo o que precisas para transformar o teu corpo em apenas 10 dias, sem custos adicionais
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredCard(index)}
              onMouseLeave={() => setHoveredCard(null)}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${benefit.color} rounded-2xl flex items-center justify-center mb-6 transition-transform duration-300 ${hoveredCard === index ? 'scale-110' : ''}`}>
                <i className={`${benefit.icon} text-3xl ${benefit.iconColor}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
              <div className="mt-6 flex items-center gap-2 text-teal-600 font-semibold">
                <i className="ri-check-line text-xl"></i>
                <span className="text-sm">Incluído Gratuitamente</span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-teal-500 to-lime-500 rounded-3xl p-12 text-center shadow-2xl">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto Para Começar?
          </h3>
          <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
            Junta-te a centenas de pessoas que já transformaram as suas vidas com o nosso desafio
          </p>
          <a
            href="#inscricao"
            className="inline-block bg-white text-teal-600 font-bold text-lg px-10 py-5 rounded-xl hover:bg-gray-50 transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-3">
              <i className="ri-rocket-line text-2xl"></i>
              COMEÇAR AGORA GRATUITAMENTE
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
